import React, { createContext, useEffect, useState } from 'react';
import { getSimpleDateFromString } from '../datelogic/simpledate';
import { validateDate } from '../util/dateUtil';
import { toNumber } from './toNumber';
export var DatepickerContext = createContext({
    day: null,
    month: null,
    year: null,
    setDay: function () { return null; },
    setMonth: function () { return null; },
    setYear: function () { return null; },
    locale: 'nb',
    calendarActiveDate: '',
    setCalendarActiveDate: function () { return null; },
    setLastChangedValue: function () { return null; },
});
var MONTHS_PER_YEAR = 12;
var MAX_DAYS = 31;
export var DatepickerProvider = function (_a) {
    var _b;
    var children = _a.children, _c = _a.value, value = _c === void 0 ? '' : _c, locale = _a.locale;
    var newDate = validateDate(value) ? getSimpleDateFromString(value) : '';
    var _d = useState(newDate ? newDate.date : null), day = _d[0], setDay = _d[1];
    var _e = useState(newDate ? newDate.month + 1 : null), month = _e[0], setMonth = _e[1];
    var _f = useState(newDate ? newDate.year : null), year = _f[0], setYear = _f[1];
    var _g = useState((_b = newDate === null || newDate === void 0 ? void 0 : newDate.toString()) !== null && _b !== void 0 ? _b : ''), calendarActiveDate = _g[0], setCalendarActiveDate = _g[1];
    var _h = useState(value !== null && value !== void 0 ? value : ''), lastChangedValue = _h[0], setLastChangedValue = _h[1];
    useEffect(function () {
        var _a;
        if (value !== lastChangedValue) {
            setDay(newDate ? newDate.date : null);
            setMonth(newDate ? newDate.month + 1 : null);
            setYear(newDate ? newDate.year : null);
            setCalendarActiveDate((_a = newDate === null || newDate === void 0 ? void 0 : newDate.toString()) !== null && _a !== void 0 ? _a : '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    return (React.createElement(DatepickerContext.Provider, { value: {
            day: day,
            month: month,
            year: year,
            setDay: function (newValue, focusNext) {
                if (focusNext === void 0) { focusNext = undefined; }
                var numbers = newValue.slice(-2);
                var first = numbers[0], second = numbers[1];
                var total = toNumber(numbers);
                if (total > MAX_DAYS) {
                    focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                }
                else if (first > 3) {
                    setDay(total);
                    focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                }
                else {
                    setDay(total);
                    if (second !== undefined) {
                        focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                    }
                }
            },
            setMonth: function (newValue, focusNext) {
                if (focusNext === void 0) { focusNext = undefined; }
                var numbers = newValue.slice(-2);
                var first = numbers[0], second = numbers[1];
                var total = toNumber(numbers);
                if (total > MONTHS_PER_YEAR) {
                    focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                }
                else if (first > 1) {
                    setMonth(total);
                    focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                }
                else {
                    setMonth(total);
                    if (second !== undefined) {
                        focusNext === null || focusNext === void 0 ? void 0 : focusNext();
                    }
                }
            },
            setYear: function (newValue) {
                setYear(toNumber(newValue.slice(-4)));
            },
            calendarActiveDate: calendarActiveDate,
            setCalendarActiveDate: function (date) {
                setCalendarActiveDate(date);
            },
            locale: locale,
            setLastChangedValue: function (val) {
                setLastChangedValue(val);
            },
        } }, children));
};
